import { CircleCheck, CircleX } from "lucide-react";
import type { ComponentType, SVGProps } from "react";
import CircleFill2Icon from "@/v2/icons/circle-fill-2.svg?react";
import CircleFill6Icon from "@/v2/icons/circle-fill-6.svg?react";
import { cn } from "@/v2/lib/utils";
import type { Entry } from "./normalize";

type StatusGlyph = ComponentType<SVGProps<SVGSVGElement>>;

const STATUS_ICON: Record<
	Entry["status"],
	{ Icon: StatusGlyph; color: string; label: string }
> = {
	tracked: {
		Icon: CircleFill2Icon,
		color: "text-status-tracked",
		label: "Tracked",
	},
	reviewed: {
		Icon: CircleFill6Icon,
		color: "text-status-reviewed",
		label: "Reviewed",
	},
	exported: {
		Icon: CircleCheck,
		color: "text-status-exported",
		label: "Exported",
	},
	deleted: {
		Icon: CircleX,
		color: "text-status-deleted",
		label: "Deleted",
	},
};

export function getStatusMeta(status: Entry["status"]) {
	return STATUS_ICON[status];
}

interface StatusIconProps {
	status: Entry["status"];
	className?: string;
}

/**
 * Shared status glyph. Keep status and matching row-action icons in one place:
 * tracked = muted amber partial circle, reviewed = steel filled circle,
 * exported = spruce circle check, deleted = controlled red circle x. Consumers
 * own sizing through `className`.
 */
export function StatusIcon({ status, className }: StatusIconProps) {
	const meta = STATUS_ICON[status];
	if (!meta) return null;
	const { Icon, color } = meta;
	return <Icon className={cn("shrink-0", color, className)} strokeWidth={2} />;
}
